export const INHOUSE_SUPPLY_TYPE_DTO = 'inhouse supply';
export const MARKET_SUPPLY_TYPE_DTO = 'market supply';
